const initialState = {
  items: [],
  listInfo: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case 'FETCH_PROCESS':
      state = {
        ...state,
        ...{
          items: action.payload || [],
          listInfo: action.listInfo,
        },
      };
      break;
  }

  return state;
};
